
// export const API_URL ="http://localhost:5000"
// export const API_URL2 ="http://localhost:5000"

// export const API_URL3="http://localhost:5000"

// export const API_URL4="http://localhost:5000"
export const terminal=1166

// export const terminal=983


export const API_URL ="https://back.allticketscol.com"
export const API_URL2 ="https://back2.allticketscol.com"
export const API_URL3="https://back.allticketscol.com"


export const API_URL4="https://back2.allticketscol.com"

export const respuesta ="https://allticketscol.com" 
//export const API_URL ="http://Allticketssegundoback-env.eba-cbpi4frv.us-east-1.elasticbeanstalk.com"
//export const API_URL2 ="http://Allticketssegundoback-env.eba-cbpi4frv.us-east-1.elasticbeanstalk.com"
export const IVA =0.19
